import React from 'react';
import { Core, Drawer, Form, Layout, Modal } from 'connex-cds';
import styled from 'styled-components';
import { WaterRelease } from './WaterRelease';
import { useTicketContext } from '../../../../TicketContext';
import { useCompanySetup } from '../../../../MasterDataProvider';
import { UnFinalize } from '../../../modal/UnFinalize';

const { Container, Row } = Layout;

const viewStates = {
  RELEASE: 'RELEASE',
  SIGNATURE: 'SIGNATURE',
};

const Styled = styled.div`
  .actions {
    @media (max-width: 410px) {
      margin-top: 80px !important;
      float: left;
    }

    @media (min-width: 411px) {
      float: right;
    }
  }
`;

export const WaterReleaseModal = ({
  renderWaterReleaseSignature,
  handleWaterReleaseReset,
  handleWaterReleaseDeclined,
  handleWaterReleaseSubmitSignature,
}) => {
  const { ticket } = useTicketContext();
  const { closeDrawer } = Drawer.useDrawerContext();
  const {
    parentFormContext: { values },
  } = Form.useFormContext();
  const { closeModal } = Modal.useModalContext();
  const [view, setView] = React.useState(viewStates.RELEASE);

  const disableSubmitSignature = React.useMemo(
    () => !values?.waterReleaseSignature?.image,
    [values?.waterReleaseSignature]
  );

  const handleAcceptWaterRelease = React.useCallback(() => {
    setView(viewStates.SIGNATURE);
  }, []);

  const handleDeclineWaterRelease = React.useCallback(() => {
    setView(viewStates.RELEASE);
    handleWaterReleaseDeclined();
    closeModal();
    closeDrawer();
  }, []);

  const handleCancelSignature = React.useCallback(() => {
    handleWaterReleaseReset();
    setView(viewStates.RELEASE);
  }, []);

  const handleSubmitSignature = React.useCallback(() => {
    setView(viewStates.SIGNATURE);
    handleWaterReleaseSubmitSignature();
    closeModal();
    closeDrawer();
  }, []);

  return (
    <>
      <Container flex={1} style={{ marginTop: '20px' }}>
        {view === viewStates.RELEASE && (
          <div>
            <WaterRelease />
            <Row>
              <Core.Button
                type="primary"
                stringId="accept"
                onClick={handleAcceptWaterRelease}
                data-testid="accept-button"
              />
              <Core.Button
                type="primary"
                stringId="decline"
                onClick={handleDeclineWaterRelease}
                data-testid="decline-button"
              />
            </Row>
          </div>
        )}
        {view === viewStates.SIGNATURE && (
          <div>
            {renderWaterReleaseSignature(ticket?.ticketId)}
            <Styled>
              <Row className="actions">
                <Core.Button
                  onClick={handleCancelSignature}
                  stringId="cancel-signature-button"
                  data-testid="cancel-signature-button"
                />
                <Core.Button
                  type="primary"
                  disabled={disableSubmitSignature}
                  onClick={handleSubmitSignature}
                  stringId="submit-signature-button"
                  data-testid="ok-button"
                />
              </Row>
            </Styled>
          </div>
        )}
      </Container>
    </>
  );
};
